import { createStore, createHook, createActionsHook } from 'react-sweet-state';
type SideNavigationCollapsedState = {
	isCollapsed: boolean;
};
const initialState: SideNavigationCollapsedState = {
	isCollapsed: false,
};
const actions = {
	setIsCollapsed:
		(collapsed: boolean) =>
		({ setState }: any) => {
			setState({ isCollapsed: collapsed });
		},
};
export const SideNavigationCollapsedStore = createStore({
	initialState,
	actions,
});

export const useSideNavigationCollapsedState = createHook(SideNavigationCollapsedStore);

export const useSideNavigationCollapsedActions = createActionsHook(SideNavigationCollapsedStore);
